import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import TooltipWrapper from 'components/TooltipWrapper';

export default class TooltipIcon extends PureComponent {
  static propTypes = {
    content: PropTypes.node.isRequired,
    trigger: PropTypes.string,
    className: PropTypes.string,
    tooltipClassName: PropTypes.string,
    preferPlace: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
    theme: PropTypes.string,
    dataTestId: PropTypes.string,
    iconType: PropTypes.string,
  };

  static defaultProps = {
    preferPlace: 'above',
    trigger: 'hover',
    size: 'md',
    iconType: 'infoCircle',
  };

  render() {
    const {
      className,
      tooltipClassName,
      size,
      theme,
      color,
      iconType,
      ...tooltipProps
    } = this.props;
    return (
      <TooltipWrapper
        theme={theme}
        className={tooltipClassName}
        {...tooltipProps}
      >
        <Icon className={className} color={color} size={size} type={iconType} />
      </TooltipWrapper>
    );
  }
}
